import { ROUTER_PATHS, useCheckPermissions, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { useGetSolicitudesIngreso } from "@/shared/actions/erp";
import { GeneralTable } from "@/shared/components/ui";
import { EstadosSolicitudIngresoEnum, SolicitudesIngreso } from "@/shared/interfaces";
import { Grid } from "@mui/material";
import useTableColumnsSolicitudIngreso from "../../shared/useTableColumnsSolicitudIngreso";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { PermissionsEnum } from "@/auth/interfaces";
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination";
import { useSinSeriesProducto } from "@/store/erp/productos/sinSeriesProductos.store";
import { useNavigate } from "react-router-dom";


type TablaSolicitudIngresoPageProps = {
  estado: string;
}
export default function TablaSolicitudIngresoPage({ estado }: TablaSolicitudIngresoPageProps) {
  useCheckPermissions(PermissionsEnum.api_view_solicitudingreso)
  //store
  const listaProducto = useSinSeriesProducto(s => s.listaProducto)
  const paginatedProductoData = useSinSeriesProducto(s => s.paginatedProductoData)
  const setPagination1 = useSinSeriesProducto(s => s.setPagination)
  const pagination1 = useSinSeriesProducto(s => s.pagination)
  const clearSelectedItems = useSinSeriesProducto(s => s.clearSelectedItems)

  const { columnsSolicitudIngreso, columnsInfoProducto, isOpenModal, setIsOpenModal } = useTableColumnsSolicitudIngreso({ estado })
  const navigate = useNavigate()
  //*hooks
  const {
    pagination,
    setPagination,
    //dateAfter,
    //dateBefore
  } = useTableFilter()

  const { pageIndex, pageSize } = pagination;
  const { columnFilters, setColumnFilters, filterObject } = useTableServerSideFiltering()
  //*FETCH
  const { data: dataSolicitudIngreso, isLoading, isRefetching } = useGetSolicitudesIngreso({
    page: pageIndex + 1,
    page_size: pageSize,
    estado_solicitud: estado,
    ...filterObject,
    filterByState: false
  })

  const onEdit = (data: SolicitudesIngreso) => {
    navigate(`${ROUTER_PATHS.inventario.solicitud_ingreso_compraNav}/editar/${data.id_solicitudingreso}`)

  }

  return (
    <>
      <Grid container spacing={2} justifyContent={'space-between'}>
        <Grid item xs={12}>
          <GeneralTable<SolicitudesIngreso>
            columns={columnsSolicitudIngreso}
            data={dataSolicitudIngreso?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={dataSolicitudIngreso?.data?.count}
            //
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}
            ///crud ///****oculta toda la columna de edicion*/
            enableEditing={estado === EstadosSolicitudIngresoEnum.ESPERA}
            enableColumnActions={true}
            positionActionsColumn="first"
            onEdit={onEdit}
          />
        </Grid>

        <ScrollableDialogProps
          open={isOpenModal}
          title="Productos "
          onCloseIcon={() => { setIsOpenModal(false), clearSelectedItems() }}
          minWidth='65%'
          contentNode={
            <Grid container spacing={3}>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <SampleTablePagination
                  columns={columnsInfoProducto}
                  data={paginatedProductoData}
                  pagination={pagination1}
                  setPagination={setPagination1}
                  rowCount={listaProducto.length}
                  rowNumber={true}

                />
              </Grid>
            </Grid>
          }
        />

      </Grid>
    </>
  )
}